var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1900 200",
    width: 1900,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 121L17.7 124C35.3 127 70.7 133 105.8 133.3C141 133.7 176 128.3 211.2 121.3C246.3 114.3 281.7 105.7 316.8 103.2C352 100.7 387 104.3 422.2 98C457.3 91.7 492.7 75.3 527.8 78.8C563 82.3 598 105.7 633.2 116.2C668.3 126.7 703.7 124.3 738.8 111C774 97.7 809 73.3 844.2 62.2C879.3 51 914.7 53 950 60.7C985.3 68.3 1020.7 81.7 1055.8 92.8C1091 104 1126 113 1161.2 113.5C1196.3 114 1231.7 106 1266.8 108C1302 110 1337 122 1372.2 118.7C1407.3 115.3 1442.7 96.7 1477.8 89.3C1513 82 1548 86 1583.2 94.7C1618.3 103.3 1653.7 116.7 1688.8 117.2C1724 117.7 1759 105.3 1794.2 97.2C1829.3 89 1864.7 85 1882.3 83L1900 81L1900 0L1882.3 0C1864.7 0 1829.3 0 1794.2 0C1759 0 1724 0 1688.8 0C1653.7 0 1618.3 0 1583.2 0C1548 0 1513 0 1477.8 0C1442.7 0 1407.3 0 1372.2 0C1337 0 1302 0 1266.8 0C1231.7 0 1196.3 0 1161.2 0C1126 0 1091 0 1055.8 0C1020.7 0 985.3 0 950 0C914.7 0 879.3 0 844.2 0C809 0 774 0 738.8 0C703.7 0 668.3 0 633.2 0C598 0 563 0 527.8 0C492.7 0 457.3 0 422.2 0C387 0 352 0 316.8 0C281.7 0 246.3 0 211.2 0C176 0 141 0 105.8 0C70.7 0 35.3 0 17.7 0L0 0Z",
    fill: "#104f2e",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveVerde);
export default __webpack_public_path__ + "static/media/wave-verde.aa1da7b8b1d8bac38007288cd78661f6.svg";
export { ForwardRef as ReactComponent };